import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useIsTruncated } from '@/hooks/use-is-truncated'
import { cn } from '@/lib/utils'
import React from 'react'

interface TextWithTooltipProps {
  text: string | number
  className?: string
  /** Classes for the tooltip itself, e.g. a max width so long text wraps. */
  contentClassName?: string
  style?: React.CSSProperties
}

export function TextWithTooltip({
  text,
  className,
  contentClassName,
  style,
}: TextWithTooltipProps) {
  const { ref, isTruncated } = useIsTruncated<HTMLDivElement>()

  return (
    <Tooltip>
      <TooltipTrigger disabled={!isTruncated} asChild>
        <div
          ref={ref}
          className={cn(
            'truncate',
            !isTruncated && 'pointer-events-none',
            className
          )}
          style={style}>
          {text}
        </div>
      </TooltipTrigger>
      <TooltipContent className={contentClassName}>{text}</TooltipContent>
    </Tooltip>
  )
}
